import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Utils from 'libs/Utils';
import request from 'superagent';
import PropTypes from 'prop-types';

import Header from 'components/Header';
import FormControl from 'components/FormControl';
import Button from 'components/Button';
import ToolTip from 'components/ToolTip';

import './styles.css';
import tooltip from './img/tooltip.svg';
import pencil from './img/pencil.svg';
import next from './img/next.svg';
import prev from './img/prev.svg';
import arrow from './img/arrow.svg';
/* Disabled for now; because the Terms of Use are not ready yet!
import external from './img/external.svg'; */

class Addresses extends Component {
  static renderIcon(coin) {
    let icon;
    switch (coin.iconType) {
      case 'vector':
        icon = (
          <img
            className="addresses__icon"
            src={coin.iconUrl}
            alt={`${coin.name} (${coin.symbol}) icon`}
            width="27"
            height="27"
          />
        );
        break;
      case 'pixel':
        icon = (
          <img
            className="addresses__icon"
            src={`${coin.iconUrl}?size=54`}
            alt={`${coin.name} (${coin.symbol}) icon`}
            width="27"
            height="27"
          />
        );
        break;
      default:
        icon = (
          <span className="addresses__icon addresses__icon--placeholder" />
        );
    }

    return icon;
  }

  constructor(props) {
    super(props);

    this.onToChange = this.onToChange.bind(this);
    this.onToExtraIdChange = this.onToExtraIdChange.bind(this);
    this.onRefundChange = this.onRefundChange.bind(this);
    this.onRefundExtraIdChange = this.onRefundExtraIdChange.bind(this);
    this.submit = this.submit.bind(this);

    this.state = {
      error: '',
      sending: false,
      toAddress: '',
      toAddressValidationError: '',
      toExtraId: '',
      toExtraIdValidationError: '',
      refundAddress: '',
      refundAddressValidationError: '',
      refundExtraId: '',
      refundExtraIdValidationError: '',
    };
  }

  onToChange(e) {
    this.setState({
      toAddress: e.target.value,
      toAddressValidationError: '',
    });
  }

  onToExtraIdChange(e) {
    this.setState({
      toExtraId: e.target.value,
      toExtraIdValidationError: '',
    });
  }

  onRefundChange(e) {
    this.setState({
      refundAddress: e.target.value,
      refundAddressValidationError: '',
    });
  }

  onRefundExtraIdChange(e) {
    this.setState({
      refundExtraId: e.target.value,
      refundExtraIdValidationError: '',
    });
  }

  submit() {
    this.setState({ error: '', sending: true });
    if (!this.state.toAddress) return this.setState({ toAddressValidationError: 'Please provide a receive address before you can continue', sending: false });
    if (!this.state.refundAddress) return this.setState({ refundAddressValidationError: 'Please provide a refund address before you can continue', sending: false });

    let fromAmount;
    if (this.props.match.params.direction === 'from') {
      fromAmount = Utils.parseNumber(this.props.match.params.amount);
    } else {
      const toAmount = Utils.parseNumber(this.props.match.params.amount);
      fromAmount = toAmount / this.props.infoStore.rate;
    }

    return request
      .post(`${process.env.REACT_APP_API_URL}/public/exchanges`)
      .set('X-Access-Token', process.env.REACT_APP_PUBLIC_KEY)
      .send({
        pair: `${this.props.infoStore.fromCoin.symbol}_${this.props.infoStore.toCoin.symbol}`,
        toAddress: this.state.toAddress.trim(),
        toExtraId: this.state.toExtraId.trim() || null,
        refundAddress: this.state.refundAddress.trim(),
        refundExtraId: this.state.refundExtraId.trim() || null,
        fromAmount,
      })
      .accept('json')
      .end((error, response) => {
        if (error && error.status === 422) {
          response.body.data.forEach((validationError) => {
            switch (validationError.param) {
              case 'toAddress':
                return this.setState({
                  toAddressValidationError: validationError.message,
                  sending: false,
                });
              case 'toExtraId':
                return this.setState({
                  toExtraIdValidationError: validationError.message,
                  sending: false,
                });
              case 'refundAddress':
                return this.setState({
                  refundAddressValidationError: validationError.message,
                  sending: false,
                });
              case 'refundExtraId':
                return this.setState({
                  refundExtraIdValidationError: validationError.message,
                  sending: false,
                });
              default:
                return this.setState({
                  error: validationError.message,
                  sending: false,
                });
            }
          });
        }
        if (error && error.status === 500) {
          return this.setState({
            error: response.body.message,
            sending: false,
          });
        }
        if (error) return console.error(error);
        if (response.body.status !== 'success') return console.error(response.body.message);

        // TODO: Maybe pre-load the exchange,
        // so we don't have to fetch it again and the data is already loaded?
        return this.props.history.push(`/exchange/${response.body.data.exchange.uuid}`);
      });
  }

  render() {
    const toAddressTooltip = (
      <ToolTip text="After we’ve exchanged your coins, you will receive them on this address.">
        <img className="addresses__information" src={tooltip} width="15" height="15" alt="Tooltip" />
      </ToolTip>
    );

    const refundAddressTooltip = (
      <ToolTip text="If something goes wrong in the exchanging process, then you will receive back the coins you’ve sent to us.">
        <img className="addresses__information" src={tooltip} width="15" height="15" alt="Tooltip" />
      </ToolTip>
    );

    let toProvider;
    for (let i = 0, l = this.props.infoStore.toCoin.providers.length; i < l; i += 1) {
      if (this.props.infoStore.toCoin.providers[i].name === this.props.infoStore.provider) {
        toProvider = this.props.infoStore.toCoin.providers[i];
        break;
      }
    }

    let fromProvider;
    for (let i = 0, l = this.props.infoStore.fromCoin.providers.length; i < l; i += 1) {
      if (this.props.infoStore.fromCoin.providers[i].name === this.props.infoStore.provider) {
        fromProvider = this.props.infoStore.fromCoin.providers[i];
        break;
      }
    }

    let fromAmount;
    let toAmount;
    if (this.props.match.params.direction === 'from') {
      fromAmount = Utils.parseNumber(this.props.match.params.amount);
      toAmount = fromAmount * this.props.infoStore.rate;
    } else {
      toAmount = Utils.parseNumber(this.props.match.params.amount);
      fromAmount = toAmount / this.props.infoStore.rate;
    }

    return (
      <div className="addresses">
        <Header step={1} error={this.state.error} light />
        <div className="addresses__content">
          <h1 className="addresses__title">
            Provide your addresses
          </h1>

          <div className="info">
            <div className="info__exchange">
              <div className="info__action">
                <Link className="info__edit" to={`/${this.props.infoStore.fromCoin.symbol}_${this.props.infoStore.toCoin.symbol}`}>
                  <img className="info__pencil" src={pencil} width="14" height="14" alt="Edit" />
                </Link>
              </div>
              <div className="conversion">
                <span className="conversion__coin">
                  <span className="conversion__amount">{Utils.roundDecimals(fromAmount, 8)}</span>
                  <span className="conversion__symbol">{this.props.infoStore.fromCoin.symbol}</span>
                </span>
                <span className="conversion__divider">
                  <img className="conversion__arrow" src={arrow} width="18" height="14" alt="Rate" />
                </span>
                <span className="conversion__coin">
                  <span className="conversion__amount">{Utils.roundDecimals(toAmount, 8)}</span>
                  <span className="conversion__symbol">{this.props.infoStore.toCoin.symbol}</span>
                </span>
              </div>
              <div className="info__action">
                <span className="info__pulsate" />
              </div>
            </div>

            <div className="rate">
              <div className="info__title">Exchange rate</div>
              <div className="info__value">1 <span className="info__symbol">{this.props.infoStore.fromCoin.symbol}</span> = {this.props.infoStore.rate} <span className="info__symbol">{this.props.infoStore.toCoin.symbol}</span></div>
            </div>

            <div className="miner_fee">
              <div className="info__title">Miner fee</div>
              <div className="info__value">{this.props.infoStore.minerFee} <span className="info__symbol">{this.props.infoStore.toCoin.symbol}</span></div>
            </div>
          </div>

          <FormControl
            type="text"
            id="toAddress"
            disabled={this.state.sending}
            color={this.state.toAddressValidationError ? 'red' : null}
            value={this.state.toAddress}
            placeholder={`${this.props.infoStore.toCoin.name} (${this.props.infoStore.toCoin.symbol}) address`}
            label="Receive address"
            tooltip={toAddressTooltip}
            onChange={this.onToChange}
            prepend={Addresses.renderIcon(this.props.infoStore.toCoin)}
          />

          {this.state.toAddressValidationError ?
            <div className="addresses__error">
              {this.state.toAddressValidationError}
            </div>
          : null}

          {toProvider.toExtraId ?
            <FormControl
              type="text"
              id="toExtraId"
              disabled={this.state.sending}
              color={this.state.toExtraIdValidationError ? 'red' : null}
              value={this.state.toExtraId}
              placeholder={`${this.props.infoStore.toCoin.name} (${this.props.infoStore.toCoin.symbol}) ${toProvider.extraIdName}`}
              label={toProvider.extraIdName}
              labelButton={<span className="addresses__optional">Optional</span>}
              onChange={this.onToExtraIdChange}
              prepend={Addresses.renderIcon(this.props.infoStore.toCoin)}
            />
          : null}

          {this.state.toExtraIdValidationError ?
            <div className="addresses__error">
              {this.state.toExtraIdValidationError}
            </div>
          : null}

          <FormControl
            type="text"
            id="refundAddress"
            disabled={this.state.sending}
            color={this.state.refundAddressValidationError ? 'red' : null}
            value={this.state.refundAddress}
            placeholder={`${this.props.infoStore.fromCoin.name} (${this.props.infoStore.fromCoin.symbol}) address`}
            label="Refund address"
            tooltip={refundAddressTooltip}
            onChange={this.onRefundChange}
            prepend={Addresses.renderIcon(this.props.infoStore.fromCoin)}
          />

          {this.state.refundAddressValidationError ?
            <div className="addresses__error">
              {this.state.refundAddressValidationError}
            </div>
          : null}

          {fromProvider.retundExtraId ?
            <FormControl
              type="text"
              id="refundExtraId"
              disabled={this.state.sending}
              value={this.state.refundExtraId}
              color={this.state.refundExtraIdValidationError ? 'red' : null}
              placeholder={`${this.props.infoStore.fromCoin.name} (${this.props.infoStore.fromCoin.symbol}) ${fromProvider.extraIdName}`}
              label={fromProvider.refundExtraId}
              labelButton={<span className="addresses__optional">Optional</span>}
              onChange={this.onRefundExtraIdChange}
              prepend={Addresses.renderIcon(this.props.infoStore.fromCoin)}
            />
          : null}

          {this.state.refundExtraIdValidationError ?
            <div className="addresses__error">
              {this.state.refundExtraIdValidationError}
            </div>
          : null}

          {/* Disabled for now; because the Terms of Use are not ready yet!
          <div className="terms-of-use">
            When you click <span className="terms-of-use__emphasize">next</span> you agree with our <a className="terms-of-use__link" href="https://support.tokenblender.com" target="_blank" rel="noopener noreferrer">Terms of use <img src={external} width="8" height="8" alt="Terms of use" /></a>
          </div> */}

          <div className="addresses__buttons">
            <Button
              full
              color="light-blue"
              text="Back"
              imgLeft={prev}
              href={`/${this.props.infoStore.fromCoin.symbol}_${this.props.infoStore.toCoin.symbol}`}
            />

            {this.state.sending ?
              <Button
                type="button"
                full
                color="light-green"
              >
                <div className="spinner" />
              </Button>
            :
              <Button
                type="button"
                full
                color="green"
                text="Next"
                imgRight={next}
                onClick={this.submit}
              />
            }
          </div>
          <p className="addresses__average-exchange-time">Average exchange time is <span className="addresses__exchange-time">{process.env.REACT_APP_EXCHANGE_TIME}</span> minutes</p>
        </div>
      </div>
    );
  }
}

Addresses.propTypes = {
  infoStore: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default Addresses;



// WEBPACK FOOTER //
// ./src/scenes/Pair/scenes/Addresses/index.jsx